import { ApiError, apiFetch } from './client';
function mapMember(u) {
    return {
        id: u.id,
        email: u.email,
        fullName: u.fullName,
        firstName: u.firstName,
        lastName: u.lastName,
        jobTitle: u.jobTitle ?? '',
        role: (u.role === 'admin' || u.role === 'reader' ? u.role : 'editor'),
    };
}
function usersError(err, fallback) {
    if (err instanceof ApiError) {
        switch (err.code) {
            case 'invalid_email':
                return 'Укажите корректный email';
            case 'invalid_full_name':
                return 'Проверьте введённые данные';
            case 'email_exists':
                return 'Пользователь с таким email уже есть';
            case 'last_admin':
                return 'Нельзя удалить или понизить последнего админа';
            case 'cannot_delete_self':
                return 'Нельзя удалить свою учётную запись';
            case 'forbidden':
                return 'Недостаточно прав';
            default:
                return fallback;
        }
    }
    return fallback;
}
export async function listUsers() {
    const data = await apiFetch('/users');
    return data.items.map(mapMember);
}
export async function inviteUser(email, fields) {
    try {
        const data = await apiFetch('/users', {
            method: 'POST',
            body: JSON.stringify({
                email,
                firstName: fields.firstName ?? '',
                lastName: fields.lastName ?? '',
                jobTitle: fields.jobTitle ?? '',
                role: fields.role ?? 'reader',
            }),
        });
        return mapMember(data.user);
    }
    catch (err) {
        throw new Error(usersError(err, 'Не удалось пригласить пользователя'));
    }
}
export async function patchUserRole(userId, role) {
    try {
        const data = await apiFetch(`/users/${userId}`, {
            method: 'PATCH',
            body: JSON.stringify({ role }),
        });
        return mapMember(data.user);
    }
    catch (err) {
        throw new Error(usersError(err, 'Не удалось изменить роль'));
    }
}
export async function deleteUser(userId) {
    try {
        await apiFetch(`/users/${userId}`, { method: 'DELETE' });
    }
    catch (err) {
        throw new Error(usersError(err, 'Не удалось удалить пользователя'));
    }
}
export const ROLE_OPTIONS = [
    { value: 'admin', label: 'Админ' },
    { value: 'editor', label: 'Редактор' },
    { value: 'reader', label: 'Читатель' },
];
export function roleSelectLabel(role) {
    return ROLE_OPTIONS.find((o) => o.value === role)?.label ?? role;
}
